import type { WithId } from '@octopus-do/octopus-project-core'
import { createAction } from '@reduxjs/toolkit'

import type { CreatePayload, UpdatePayload } from './types'

export const CommentsActions = {
  delete: createAction<WithId>('COMMENT_DELETE_SAGA'),
  update: createAction<UpdatePayload>('COMMENT_UPDATE_SAGA'),
  create: createAction<CreatePayload>('COMMENT_CREATE_SAGA'),
}
